// Import Swiper JS
import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'

function slider() {
  const swipers = document.querySelectorAll('.swiper')

  swipers.forEach((swiperEl) => {
    // Skip Swiper instances that are managed by section-specific controllers.
    if (
      swiperEl.hasAttribute('data-mitopure-swiper') ||
      swiperEl.closest('[data-mitopure-transformation]')
    ) {
      return
    }

    const columnsDesktop = parseInt(swiperEl.dataset.columnsDesktop) || 1
    const columnsMobile = parseInt(swiperEl.dataset.columnsMobile) || 1
    const spaceBetween = parseInt(swiperEl.dataset.spaceBetween) || 0
    const spaceBetweenMobile =
      parseInt(swiperEl.dataset.spaceBetweenMobile) || 0

    // eslint-disable-next-line no-unused-vars
    const swiper = new Swiper(swiperEl, {
      // Import required modules
      modules: [Pagination, Navigation],

      // Optional parameters
      slidesPerView: columnsMobile,
      spaceBetween: spaceBetweenMobile,

      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: columnsDesktop,
          spaceBetween,
        },
      },

      // Pagination configuration
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // // And if we need scrollbar
      // scrollbar: {
      // el: '.swiper-scrollbar',
      // },
    })
  })
}
export default slider
